// extracted by mini-css-extract-plugin
export default {"container":"Qb","overlay":"Rb","videoOverlay":"Sb","header":"Tb","close":"Ub","content":"Vb"};